export default "__VITE_ASSET__537681bc__"